"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _responsiveProps = require("../../../internal/responsiveProps");
var _Wrapper = _interopRequireDefault(require("../../Wrapper"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledBackgroundImage = (0, _styledComponents.default)(props => /*#__PURE__*/_react.default.createElement(_Wrapper.default, _extends({
  omitProps: {
    keys: ['formatImagePath', 'imagePath', 'ext', 'cover', 'backgroundPosition', 'backgroundColor'],
    responsiveKeys: ['imageWidth']
  },
  background: props.backgroundColor
}, props))).withConfig({
  displayName: "StyledBackgroundImage",
  componentId: "sc-tuuabc-0"
})(["background-repeat:no-repeat;", " ", " ", ""], _ref => {
  let {
    cover,
    backgroundPosition
  } = _ref;
  return (cover || backgroundPosition) && `
    background-position: ${backgroundPosition || '50% 50%'};
  `;
}, _ref2 => {
  let {
    cover
  } = _ref2;
  return cover && `background-size: cover;`;
}, _ref3 => {
  let {
    imagePath,
    formatImagePath,
    ext,
    cover,
    ...props
  } = _ref3;
  return (0, _responsiveProps.responsiveCssProps)({
    props,
    propName: 'imageWidth',
    cssProperty: 'background-image',
    output: width => (0, _styledComponents.css)(["background-image:url('", "');background-size:", ";@media screen and (-webkit-min-device-pixel-ratio:2){background-image:url('", "');}"], formatImagePath({
      imagePath,
      ext,
      width
    }), cover ? '' : `${width}px`, formatImagePath({
      imagePath,
      ext,
      width: width * 2
    }))
  });
});

/**
## Usage

```jsx
import { BackgroundImageWrapper } from '@farewill/ui'
```

## Notes

`<BackgroundImageWrapper>` extends from the `<Wrapper>` component, adding background-image functionality with a responsive `imageWidth` prop. `imageWidth` describes the width of the requested asset, not the rendered width of the element. This should be the maximum width that the image will take up at each breakpoint.

`<BackgroundImageWrapper>` expects a `imagePath` prop. By default it assumes images are stored in Cloudinary, so the `imagePath` can be provided as a shorthand of `[folder]/[image name]`. If the image you want to use is hosted elsewhere, you can use the `formatImagePath` prop for finer control of the generated image paths.
 */
const BackgroundImage = _ref4 => {
  let {
    children = null,
    ext = 'png',
    formatImagePath = _ref5 => {
      let {
        imagePath,
        ext,
        width
      } = _ref5;
      return `${_constants.CLOUDINARY_ROOT_PATH}/c_scale,f_auto,q_auto,w_${width}/${imagePath}.${ext}`;
    },
    ...props
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(StyledBackgroundImage, _extends({
    ext: ext,
    formatImagePath: formatImagePath
  }, props), children);
};
var _default = exports.default = BackgroundImage;